import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(`as-goals-scored`)
}
const _hoisted_2 = { class: "as-goals-scored__head" }
const _hoisted_3 = { class: "as-history" }
const _hoisted_4 = { class: "as-history-item" }
const _hoisted_5 = { class: "as-history-item__head" }
const _hoisted_6 = { class: "as-history-item__body" }
const _hoisted_7 = {
  key: 0,
  class: "as-competition"
}
const _hoisted_8 = { class: "as-competition__table" }
const _hoisted_9 = { class: "as-center a" }
const _hoisted_10 = { class: "as-center a" }
const _hoisted_11 = {
  key: 1,
  class: "as-competition"
}
const _hoisted_12 = { class: "as-competition__table" }
const _hoisted_13 = { class: "as-center a" }
const _hoisted_14 = { class: "as-center a" }

import IconCard from '~src/components/icons/foot_stats/IconCard.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref } from 'vue';
import { getClassForItem } from '~src/helpers/footystats';

    
const __default__ = {};

interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Card',
  props: {
    match: {},
    mode: { default: 'as-win' },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

    const props = __props

    const activeTab = ref('all')
    const setActiveTab = (tab: string) => {
        activeTab.value = tab;
    };

    const getValueWithMode = (team = 'home', mode = 'btts', half = 1) => {
        const __data: IStatsParent | null =
            props.footyStats
                ? (team === 'home'
                    ? props.footyStats.home_team_last_x
                    : props.footyStats.away_team_last_x)
                : null;
        let __number = 0;
        if(!__data || !__data.stats || !__data.stats.additional_info){
            return 0;
        }

        const additional_info = __data.stats.additional_info;

        if(__data){
            switch(mode){
                case 'ts_h1':
                    __number = additional_info?.fh_cards_for_overall ?? 0;
                    break;
                case 'ts_h2':
                    __number = additional_info['2h_cards_for_overall'] as number ?? 0;
                    break;
                case 'tb_h1':
                    __number = additional_info?.fh_cards_total_overall ?? 0;
                    break;
                case 'tb_h2':
                    __number = additional_info['2h_cards_total_overall'] as number ?? 0;
                    break;

                case '1h_over_05':
                    __number = additional_info?.fh_cards_for_over05_percentage_overall ?? 0;
                    break;
                case '2h_over_05':
                    __number = additional_info['2h_cards_for_over05_percentage_overall'] as number ?? 0;
                    break;
                case '1h_total_under_2':
                    __number = additional_info?.fh_total_cards_under2_percentage_overall ?? 0;
                    break;
                case '2h_total_under_2':
                    __number = additional_info['2h_total_cards_under2_percentage_overall'] as number ?? 0;
                    break;
                case '1h_total_23':
                    __number = additional_info?.fh_total_cards_2to3_percentage_overall ?? 0;
                    break;
                case '2h_total_23':
                    __number = additional_info['2h_total_cards_2to3_percentage_overall'] as number ?? 0;
                    break;
                case '1h_total_over_3':
                    __number = additional_info?.fh_total_cards_over3_percentage_overall ?? 0;
                    break;
                case '2h_total_over_3':
                    __number = additional_info['2h_total_cards_over3_percentage_overall'] as number ?? 0;
                    break;
            }
        }


        return __number
    }

    const calculatorAVG = (home: number, away: number) => {
        const _avg = (home + away) / 2

        return Math.round(_avg)
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconCard),
      _createVNode(IconCard, { fill: "#B81616" }),
      _cache[2] || (_cache[2] = _createElementVNode("span", null, " Thẻ (Hiệp 1/2) ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", { 'as-active': activeTab.value === 'all' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('all')))
          }, " Trung bình hiệp 1/2 ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", { 'as-active': activeTab.value === 'half' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('half')))
          }, " Trên 0.5 ~ 3 ", 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (activeTab.value === 'all')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("th", null, "Thẻ H1/H2", -1)),
                      _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("th", { class: "as-center a" }, "AVG", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("td", null, "TB TS thẻ H1", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'ts_h1'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'ts_h1')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'ts_h1'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'ts_h1')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'ts_h1'), getValueWithMode('away', 'ts_h1')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'ts_h1'), getValueWithMode('away', 'ts_h1'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("td", null, "TB TS thẻ H2", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'ts_h2'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'ts_h2')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'ts_h2'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'ts_h2')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'ts_h2'), getValueWithMode('away', 'ts_h2')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'ts_h2'), getValueWithMode('away', 'ts_h2'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("td", null, "Thẻ TB H1", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'tb_h1'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'tb_h1')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'tb_h1'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'tb_h1')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'tb_h1'), getValueWithMode('away', 'tb_h1')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'tb_h1'), getValueWithMode('away', 'tb_h1'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("td", null, "Thẻ TB H2", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', 'tb_h2'))}`)
                      }, _toDisplayString(getValueWithMode('home', 'tb_h2')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', 'tb_h2'))}`)
                      }, _toDisplayString(getValueWithMode('away', 'tb_h2')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', 'tb_h2'), getValueWithMode('away', 'tb_h2')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', 'tb_h2'), getValueWithMode('away', 'tb_h2'))), 3)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (activeTab.value === 'half')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("table", _hoisted_12, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("th", null, "Thẻ H1/H2", -1)),
                      _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[10] || (_cache[10] = _createElementVNode("th", { class: "as-center a" }, "AVG", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("td", null, "1H Over 0.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', '1h_over_05'))}`)
                      }, _toDisplayString(getValueWithMode('home', '1h_over_05')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', '1h_over_05'))}`)
                      }, _toDisplayString(getValueWithMode('away', '1h_over_05')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', '1h_over_05'), getValueWithMode('away', '1h_over_05')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', '1h_over_05'), getValueWithMode('away', '1h_over_05'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[12] || (_cache[12] = _createElementVNode("td", null, "2H Over 0.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', '2h_over_05'))}`)
                      }, _toDisplayString(getValueWithMode('home', '2h_over_05')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', '2h_over_05'))}`)
                      }, _toDisplayString(getValueWithMode('away', '2h_over_05')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', '2h_over_05'), getValueWithMode('away', '2h_over_05')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', '2h_over_05'), getValueWithMode('away', '2h_over_05'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("td", null, "1H Total Under 2", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', '1h_total_under_2'))}`)
                      }, _toDisplayString(getValueWithMode('home', '1h_total_under_2')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', '1h_total_under_2'))}`)
                      }, _toDisplayString(getValueWithMode('away', '1h_total_under_2')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', '2h_total_under_2'), getValueWithMode('away', '2h_total_under_2')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', '1h_total_under_2'), getValueWithMode('away', '1h_total_under_2'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[14] || (_cache[14] = _createElementVNode("td", null, "2H Total Under 2", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', '2h_total_under_2'))}`)
                      }, _toDisplayString(getValueWithMode('home', '2h_total_under_2')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', '2h_total_under_2'))}`)
                      }, _toDisplayString(getValueWithMode('away', '2h_total_under_2')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', '2h_total_under_2'), getValueWithMode('away', '2h_total_under_2')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', '2h_total_under_2'), getValueWithMode('away', '2h_total_under_2'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("td", null, "1H is 2~3 Total", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', '1h_total_23'))}`)
                      }, _toDisplayString(getValueWithMode('home', '1h_total_23')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', '1h_total_23'))}`)
                      }, _toDisplayString(getValueWithMode('away', '1h_total_23')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', '1h_total_23'), getValueWithMode('away', '1h_total_23')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', '1h_total_23'), getValueWithMode('away', '1h_total_23'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("td", null, "2H is 2~3 Total", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', '2h_total_23'))}`)
                      }, _toDisplayString(getValueWithMode('home', '2h_total_23')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', '2h_total_23'))}`)
                      }, _toDisplayString(getValueWithMode('away', '2h_total_23')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', '2h_total_23'), getValueWithMode('away', '2h_total_23')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', '2h_total_23'), getValueWithMode('away', '2h_total_23'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("td", null, "1H Total Over 3", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', '1h_total_over_3'))}`)
                      }, _toDisplayString(getValueWithMode('home', '1h_total_over_3')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', '1h_total_over_3'))}`)
                      }, _toDisplayString(getValueWithMode('away', '1h_total_over_3')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', '1h_total_over_3'), getValueWithMode('away', '1h_total_over_3')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', '1h_total_over_3'), getValueWithMode('away', '1h_total_over_3'))), 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[18] || (_cache[18] = _createElementVNode("td", null, "2H Total Over 3", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', '2h_total_over_3'))}`)
                      }, _toDisplayString(getValueWithMode('home', '2h_total_over_3')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', '2h_total_over_3'))}`)
                      }, _toDisplayString(getValueWithMode('away', '2h_total_over_3')), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(calculatorAVG(getValueWithMode('home', '2h_total_over_3'), getValueWithMode('away', '2h_total_over_3')))}`)
                      }, _toDisplayString(calculatorAVG(getValueWithMode('home', '2h_total_over_3'), getValueWithMode('away', '2h_total_over_3'))), 3)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})